var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface-selected)",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h16A3.5 3.5 0 0 1 23.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-surface-selected)",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h16A3.5 3.5 0 0 1 23.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-selected)",
  fillRule: "evenodd",
  d: "M17.767 7.892a.75.75 0 0 1 .03 1.06l-6.753 7.128a.75.75 0 0 1-1.075.014l-3.751-3.751a.75.75 0 0 1 1.06-1.06l3.207 3.206 6.222-6.568a.75.75 0 0 1 1.06-.029",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 84,
  height: 8,
  x: 36,
  y: 8,
  fill: "var(--hop-neutral-border-weak)",
  rx: 4
})));
export default SvgCheckbox;